// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1dtCr","header":"MessagesList_header__2u40V","chat":"MessagesList_chat__1kep1"};